import BaseService from './BaseService'
import _ from 'lodash'

export default class EventRouter extends BaseService {
  constructor(host, options) {
    super(host, options)

    const deleteKeys = []
    _.each(this.EVENTS, (fn, eventName) => {
      if (eventName.includes('|')) {
        deleteKeys.push(eventName)
        eventName.split('|').forEach(synonymEventName => (this.EVENTS[synonymEventName] = fn))
      }
    })
    deleteKeys.forEach(k => delete this.EVENTS[k])
  }

  emit(event) {
    if (this.EVENTS[event.type]) {
      this.EVENTS[event.type].call(this, event)
    } else {
      this.logger.info(`unhandled event: ${event.type}`, event.data)
    }
  }

  EVENTS = {
    ['bang'](event) {
      this.host.groups.reactToBangEvent(event)
    },

    ['client_advisory'](event) {
      switch (event.data['advisory']['name']) {
        case 'replay_start':
          this.host.reactToAdvisoryEvent('replayStart', {
            replayMessageCount: event.data['advisory']['replay_message_count']
          })
          break

        case 'replay_stop':
          this.host.reactToAdvisoryEvent('replayStop')
          break
      }
    },

    ['escalations'](event) {
      this.host.escalations.reactToEscalationsEvent(event)
    },

    ['friends'](event) {
      this.host.conversations.reactToFriendsEvent(event)
    },

    ['message|group_message'](event) {
      this.host.conversations.reactToMessageEvent(event)
    },

    ['message:status|group:message:status'](event) {
      this.host.messages.reactToMessageStatusEvent(event)
    },

    ['presence'](event) {
      this.host.presence.reactToPresenceEvent(event)
    },

    ['update'](event) {
      this.host.conversations.reactToUpdateEvent(event)
    },

    ['update:tag'](event) {
      this.host.roleTags.reactToUpdateEvent(event)
    },

    // TODO test
    ['account:settings'](event) {
      event.data['services'].forEach(service => {
        switch (service['xmlns']) {
          case 'tigertext:iq:update:account': {
            const userId = service['account'] || event.data['token']
              // issue a refresh for user - will inject into store
            this.host.users.refresh(userId)
          } break
          case 'tigertext:iq:update:org_settings': {
            // need to reload all orgs
            this.host.organizations.refreshAll()
          } break

          default:
            this.logger.warn(`unhandled account:settings service type ${service['xmlns']}`)
        }
      })
    },

    ['message:is_typing'](event) {
      this.host.typingStatus.reactToIsTypingEvent(event)
    },

    ['processing:start'](event) {
      this.host.conversations.reactToProcessingStart(event)
    },

    ['processing:stop'](event) {
      this.host.conversations.reactToProcessingStop(event)
    },

    async ['remote_wipe'](event) {
      this.host.notifications.disconnect()

      // Wait until TS-5385 is finished before uncommenting this, since it will cause future calls to
      // have a 429 error.
      //
      // await this.host.notifications.signOut({ fromServer: true })

      this.host.signOut({ fromServer: true })
    },

    ['validated'](event) {
      this.logger.warn('validated not implemented')
    },

    ['msg:metadata_update'](event) {
      this.logger.warn('msg:metadata_update not implemented')
    },

    ['conversation_mute'](event) {
      this.host.mute.reactToMuteEvent(event)
    },

    ['reconnect'](event) {
      this.host.events.reconnect()
    },

    ['push:credentials']: () => null,
    ['sse:heartbeat']: () => null,
    ['sse:keepalive']: () => null,
  }
}
